module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.detailsUser,
      "withBody": false,
      "withFooter": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('div', {
    staticClass: "form-flex"
  }, [(this.user.role) ? _c('span', {
    staticClass: "badge badge-default"
  }, [_vm._v(_vm._s(_vm.$t(this.user.role.identifier).label))]) : _vm._e(), _vm._v(" "), _c('button-actions', {
    attrs: {
      "identifier": ("user-item-actions-" + (_vm.user._id.$oid))
    }
  }, [_c('li', [(_vm.hasAdminAccess) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.showModalUserRoles()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Perfil de Acesso")]) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.showModal()
      }
    }
  }, [_vm._v("Desvincular usuário")])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eb071bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Card.vue
// module id = 3025
// module chunks = 0